<script>
import Checkbox from 'vue-material-checkbox'

const TOPPING_NOT_LISTED = '&_toppingNotListed'

export default {
  name: 'ProductToppingsList',
  components: {
    Checkbox,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      selectedToppings: [],
      productLost: false,
      toppingNotListed: false,
      describedTopping: '',
      selectedProduct: {},
    }
  },
  watch: {
    productLost () {
      if (this.productLost) {
        this.selectedToppings = []
        this.toppingNotListed = false
      }
      this.keepProductSelected()
    },
    selectedToppings () {
      if (this.selectedToppings.length > 0) {
        this.productLost = false
      }
      this.keepProductSelected()
    },
    describedTopping () {
      if (this.describedTopping) {
        // eslint-disable-line
        const topping = Object.assign(
          {},
          {
            category: TOPPING_NOT_LISTED,
            price: 0,
            units: 1,
            value: this.describedTopping,
          }
        )

        const toppingId = this.findToppingNotListed()
        if (toppingId === -1) {
          this.selectedToppings.push(topping)
        } else {
          this.selectedToppings[toppingId] = topping
        }
        this.keepProductSelected()
      } else if (this.toppingNotListed) {
        // remove TOPPING_NOT_LISTED from the array
        this.selectedToppings = this.selectedToppings.filter(({ category }) => category !== TOPPING_NOT_LISTED)
      }
    },
    toppingNotListed () {
      if (!this.toppingNotListed) {
        const toppingId = this.findToppingNotListed()
        if (toppingId !== -1) {
          this.selectedToppings.splice(toppingId, 1)
        }
      } else {
        this.productLost = false
        this.describedTopping = ''
      }
    },
  },
  methods: {
    findToppingNotListed: function () {
      return this.selectedToppings.findIndex(
        tp => tp.category === TOPPING_NOT_LISTED
      )
    },
    async keepProductSelected () {
      let isSelected = false
      if (this.selectedToppings.length > 0) {
        isSelected = true
      } else if (this.productLost) {
        isSelected = true
      }
      await this.buildSelectedProduct(isSelected)

      const selectedProduct = this.selectedProduct
      this.$emit('isProductSelected', {
        isSelected,
        selectedProduct,
      })
    },
    buildSelectedProduct (isSelected) {
      this.selectedProduct = Object.assign({}, this.product, { product_compensation_type: 'product' })
      if (isSelected) {
        this.selectedProduct.toppings = this.selectedToppings
        this.selectedProduct.include = true
      } else {
        this.selectedProduct.toppings = []
        this.selectedProduct.include = false
      }
    },
  },
}
</script>
<template>
  <div :class="$style.container">
    <div :class="$style.allProduct">
      <div :class="$style.allProduct__title">
        <label for="t.value">{{ componentData.subtitle }}</label>
      </div>
      <div :class="$style.allProduct__checkbox">
        <Checkbox
          v-model="productLost"
          :size="18"
          :class="$style.allProduct__title__toppingCheckbox"
          color="#332926"
        />
      </div>
    </div>

    <template v-for="(t,i) in product.toppings">
      <div
        :class="$style.allProduct"
        :key="i">
        <div :class="$style.allProduct__title">
          <label for="t.value">{{ t.value || t.description }}</label>
        </div>
        <div :class="$style.allProduct__checkbox">
          <Checkbox
            :id="t.value"
            v-model="selectedToppings"
            :size="18"
            :class="$style.allProduct__title__toppingCheckbox"
            :value="t"
            color="#332926"
          />
        </div>
      </div>
    </template>

  </div>
</template>

<style lang="scss" scoped module>
@import '@design';

.container {
  padding-left: .5rem;
  background-color: $background-container !important;

  .allProduct {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0.8em 0;
    border-bottom: 1px solid $divider-gray;

    &__title {
      width:100%;
      font-size: 1.2rem;
      color: $text-gray;
      text-align: left;

      &__toppingCheckbox {
        margin: 0 !important;
      }
    }

    &__checkbox * {
      padding-bottom: .5em;
      margin: 0;
      margin-top: 0;
    }
  }
}
</style>
